import { useState, useEffect } from 'react';

// types
import { Employee, UseFilteredListProps } from '../types';

// components
import Highlight from '../../components/backlight-text';

export default function useFilteredList({ list }: UseFilteredListProps): {
  list: Employee[];
  onSearch: (data: string) => void;
} {
  const [filteteredList, setFilteteredList] = useState<Employee[] | undefined>(
    undefined,
  );

  const onSearch = (searchQuery: string) => {
    if (searchQuery?.length) {
      const filtered = list
        .map((item: Employee) => {
          if (
            item?.profile?.firstName
              ?.toLowerCase()
              .includes(searchQuery?.toLowerCase()) ||
            item?.profile?.lastName
              ?.toLowerCase()
              .includes(searchQuery?.toLowerCase()) ||
            `${item?.profile?.firstName?.toLowerCase()} ${item?.profile?.lastName?.toLowerCase()}`.includes(
              searchQuery?.toLowerCase(),
            )
          ) {
            return {
              ...item,
              highlight: (
                <Highlight
                  searchQuery={searchQuery}
                  text={`${item.profile?.firstName} ${item.profile?.lastName}`}
                />
              ),
            };
          }
          return null;
        })
        .filter((item) => item);

      setFilteteredList(filtered as Employee[]);
    } else if (!searchQuery) {
      setFilteteredList(list);
    }
  };

  useEffect(() => {
    if (list && list.length && !filteteredList) {
      setFilteteredList(list);
    }
  }, [list, filteteredList]);

  return {
    list: filteteredList as Employee[],
    onSearch,
  };
}
